import React from 'react'
import { useDispatch } from 'react-redux'
import { VehicleProvider } from '@cbgms/api/modules/enums'
import { getVehicleSuggestionsWithProvider } from 'app/vehicles/state/actions'
import { IGenericVehicle } from '@cbgms/api'

export const useGetVehicleSuggestionsForProvider = (): [
  IGenericVehicle[] | null,
  (vehicleUUID: string, provider: VehicleProvider) => Promise<void>,
  boolean
] => {
  const [suggestions, setSuggestions] = React.useState<IGenericVehicle[] | null>(null)
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const dispatch = useDispatch()

  const getVehicleSuggestions = async (vehicleUUID: string, provider: VehicleProvider) => {
    setSuggestions(null)
    setIsLoading(true)
    try {
      const { Data } = await dispatch(getVehicleSuggestionsWithProvider(vehicleUUID, provider))
      setSuggestions(Data)
    } catch (e) {
      setSuggestions(null)
    } finally {
      setIsLoading(false)
    }
  }

  return React.useMemo(() => [suggestions, getVehicleSuggestions, isLoading], [suggestions, isLoading])
}
